<script setup lang="ts">
import { ref } from 'vue'
import { useMusicPlayerStoreHook } from '@/store/modules/musicPlayer'

const musicPlayerStore = useMusicPlayerStoreHook()
const drawerVisibleList = ref(musicPlayerStore.drawerVisibleList)
const musicList = ref(musicPlayerStore.playlist)
const currentPlayIndex = ref(0)
const isModal = ref(true) // 是否显示遮罩
watch(
  () => musicPlayerStore.drawerVisibleList,
  (newVal) => {
    drawerVisibleList.value = newVal
  },
)

watch(
  () => musicPlayerStore.playlist,
  (newVal) => {
    musicList.value = newVal
  },
  {
    immediate: true,
  },
)
watch(
  () => musicPlayerStore.currentSongIndex,
  (newVal) => {
    currentPlayIndex.value = newVal
  },
)
const handleCloseDrawer = () => {
  musicPlayerStore.closeDrawerList()
}

const handleOpenDrawer = () => {
  musicPlayerStore.openDrawerList()
}

const isPlaying = (index: number) => {
  return (
    musicPlayerStore.currentSongIndex === index &&
    currentPlayIndex.value === index &&
    musicPlayerStore.isPlaying
  )
}
/**
 * 暂停播放
 */
const stopMusic = () => {
  musicPlayerStore.togglePlay()
  // musicPlayerStore.setCurrentSongIndex(null)
  currentPlayIndex.value = null
}
/**
 * 播放音乐
 */
const broadcastMusic = (index: number) => {
  musicPlayerStore.setPlaylist(musicList.value)
  musicPlayerStore.setCurrentSongIndex(index)
  musicPlayerStore.togglePlay()
  currentPlayIndex.value = index
}
const loadMore = () => {
  console.log('loadMore')
}
// watch(
//   () => musicPlayerStore.isFullscreen,
//   (newVal) => {
//     isModal.value = !newVal
//   },
// )
</script>
<template>
  <el-drawer
    v-model="drawerVisibleList"
    title="音乐列表"
    direction="rtl"
    :z-index="999"
    :modal="true"
    size="300px"
    @close="handleCloseDrawer"
    @open="handleOpenDrawer"
  >
    <div
      class="flex flex-col gap-[12px] h-[calc(100vh-180px)] overflow-y-auto"
      v-infinite-scroll="loadMore"
    >
      <transition-group name="music-list-item" tag="div" class="music-list-container">
        <div
          v-for="(item, index) in musicList"
          :key="index"
          class="flex items-center border-[1px] border-[#eaeaea] bg-white rounded-[5px] p-[10px] justify-between hover:bg-[#f5f7fa] transition-all duration-300 hover:translate-y-[-2px] hover:shadow-[0 6px 16px rgba(0, 0, 0, 0.12)] hover:border-transparent cursor-pointer music-list-item"
          :style="{ animationDelay: index * 0.05 + 's' }"
          @click="broadcastMusic(index)"
          :class="{ '!bg-[#D9E8FA]': index === currentPlayIndex }"
        >
          <div class="flex items-center">
            <div class="flex items-center w-[40px]" v-if="item.thumbnailUrl || item.imageUrl">
              <img
                :src="item.thumbnailUrl || item.imageUrl"
                class="w-[40px] h-[40px] rounded-[5px]"
              />
            </div>
            <div class="flex flex-col ml-[10px]">
              <div class="text-[14px] w-[160px] text-nowrap text-ellipsis overflow-hidden">
                {{ item.title }}
              </div>
              <div
                class="text-[12px] text-[#a9a9a9] mt-[5px] w-[160px] text-nowrap text-ellipsis overflow-hidden"
              >
                {{ item?.voiceClone?.name || 'aimusic灵镜' }}
              </div>
            </div>
          </div>
          <div class="flex items-center w-[20px]">
            <el-tooltip content="暂停" placement="top" effect="dark" v-if="isPlaying(index)">
              <img
                src="@/assets/music/stop.svg"
                class="w-[20px] h-[20px]"
                @click.stop="stopMusic()"
              />
            </el-tooltip>
            <el-tooltip content="播放" placement="top" effect="dark" v-else>
              <img src="@/assets/music/broadcast.svg" class="w-[20px] h-[20px]" />
            </el-tooltip>
          </div>
        </div>
      </transition-group>
    </div>
  </el-drawer>
</template>
<style scoped lang="scss">
:deep(.el-drawer__header) {
  margin-bottom: 12px !important;
}

.music-list-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.music-list-item {
  animation: fadeInUp 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) both;
  will-change: transform, opacity;
}

/* 列表项进入/离开动画 */
.music-list-item-enter-active,
.music-list-item-leave-active {
  transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.music-list-item-enter-from,
.music-list-item-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

.music-list-item-move {
  transition: transform 0.4s ease;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
